export default __webpack_public_path__ + "static/media/Resume.e8d57577.pdf";